const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      background: theme.colors[1],
      color: theme.colors[0],
      paddingTop: props => (props.headerHeight + 50),
      [theme.mediaInverse.sm]: {
        paddingTop: props => (props.headerHeight + 40),
      },
    },
    wrapper: {
      extend: theme.wrapper,
    },
    description: {
      marginTop: 100,
      fontSize: 24,
      lineHeight: 1.2,
    },
    productTable: {
      marginTop: 100,
    },
    download: {
      marginTop: 100,
    },
    gallery: {
      marginTop: 100,
      marginBottom: 150,
    },
    hero: {
      marginTop: 100,
    },
  }


  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    content: {
      padding: '0 6vw',
    },
    description: {
      marginTop: 50,
      marginBottom: 50,
    },
  }

  return output
}

export default style
